import { LatestClosedPeriod } from '../../../types/api';

interface CostCenter {
  Id: string;
  Name: string;
  Number?: number;
  IsActive?: boolean;
  Items?: Array<{
    Id: string;
    Name: string;
    ShortName: string;
    IsActive: boolean;
    CreatedUtc: string;
    CostCenterId: string;
  }>;
}

interface CompanySettings {
  Name: string;
  CorporateIdentityNumber?: string;
  CurrencyCode?: string;
  CountryCode?: string;
  Address1?: string;
  PostalCode?: string;
  City?: string;
  Phone?: string;
  Email?: string;
  Website?: string;
}

export type ReportScopeDataSnapshot = {
  costCenters: CostCenter[];
  costCentersError: string | null;
  companySettings: CompanySettings | null;
  companySettingsError: string | null;
  latestClosedPeriod: LatestClosedPeriod | null;
  latestClosedPeriodError: string | null;
};

export const reportScopeDataCache = new Map<string, ReportScopeDataSnapshot>();
export const inFlightReportScopeFetches = new Map<string, Promise<ReportScopeDataSnapshot>>();

export const clearReportScopeDataCache = () => {
  reportScopeDataCache.clear();
  inFlightReportScopeFetches.clear();
};